import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/edge-gateways/$id/")({
  staticData: {
    title: "edge.navigation.edgeGateways",
  },
  loader: ({ params }) =>
    redirect({
      to: "/sources/edge-gateways/$id/overview",
      params: { id: params.id },
      replace: true,
    }),
});
